let isLoggingOut = false;

export const getIsLoggingOut = () => isLoggingOut;
export const setIsLoggingOut = (value) => {
  isLoggingOut = value;
};
